var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header-wrap"},[_c('div',{staticClass:"header-content"},[_vm._m(0),_c('nav-bar')],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logo"},[_c('img',{attrs:{"src":require("assets/image/logo/himo-logo.png"),"alt":""}})])
}]

export { render, staticRenderFns }